// extracted by mini-css-extract-plugin
export var large = "loadingIndicator-module--large--gDOkJ";
export var loader = "loadingIndicator-module--loader--ZXJEC";
export var loadingWrapper = "loadingIndicator-module--loadingWrapper--YKY85";
export var medium = "loadingIndicator-module--medium--37S9L";
export var spin = "loadingIndicator-module--spin--YWgN0";
export var tiny = "loadingIndicator-module--tiny--xAyc9";